
import { auth, signIn } from "@/store/db";

import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class LoginView extends Vue {
  email = "";
  password = "";

  pressed() {
    if (this.email && this.password) {
      signIn(this.email, this.password);
      this.email = "";
      this.password = "";
      console.log(auth);
      //   this.$router.push({ name: "home" }); eğer vue içinde olsaydı bu şekilde yazacaktık. Ancak db.ts içinde yönlendirme yaptım.Bu yüzden router.push({name:"home"}) şeklinde yazdım.
    }
  }
}
